import React, {useState, useEffect, useRef, useCallback, forwardRef} from "react";

import {ReactComponent as NotificationIcon} from "../pages/account/profile/profile_icon/notification-icon.svg";
import PromoBanner from "./promoBanner.js";
import Select from "react-select";
import Modal from "react-modal";
import "./CryptoPage.css"; // Assuming you have a CSS file for styling
import TableCell, {tableCellClasses} from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import UserAvatar from "./userAvatar.js";
import {styled} from "@mui/material/styles";
import Box from "@mui/material/Box";
import json2mq from "json2mq";
import useMediaQuery from "@mui/material/useMediaQuery";
import Typography from "@mui/material/Typography";
import {useNavigate} from "react-router-dom";
import BottomNavigationAction from "@mui/material/BottomNavigationAction";
import {BottomNavigation, Button, CircularProgress} from "@mui/material";
import SidebarMenuList from "../includes/sidebarMenuList.jsx";

import IconButton from "@mui/material/IconButton";
import Drawer from "@mui/material/Drawer";
import {useLocation, Link} from "react-router-dom";
import {Helmet} from "react-helmet";

import Dialog from "@mui/material/Dialog";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import {Card, TextField} from "@mui/material";

import {DialogTitle, DialogContent, DialogActions} from "@mui/material"; // Import Material-UI components

import {addToPortfolio} from "../apihelper/portfolio";

import CloseIcon from "@mui/icons-material/Close";

import CreatableSelect from "react-select/creatable";
import {getTotalunit, getFetchdropdown} from "../apihelper/cryptocurrencylist";
import Alert from "@mui/material/Alert";
import Snackbar from "@mui/material/Snackbar";
import {tabLink} from "../common/constant/tablink.jsx";
import {BEST_PREDICTION_PAGE} from "../common/constant/SubscriptionFeatures.jsx";
import {getUserAccessPermission} from "../apihelper/profile.js";
import {BEST_PREDICTION_MESSAGE, LOGIN_MESSAGE} from "../common/constant/SubscriptionMessage.jsx";
import {leftRightMotion} from "../common/constants.jsx";
import GoToSubscribeAlert from "../common/alert/GoToSubscribeAlert.jsx";
import GoogleLoginHandler from "../common/hooks/GoogleLoginHandler.jsx";
import BottomTab from "../common/hooks/BottomTab.jsx";
import LoginPopUp from "../common/alert/login/LoginPopUp.jsx";

const SkeletonLoaderMobile = () => {
    return (
        <div
            style={{
                background: "linear-gradient(180deg, rgba(24, 119, 242, 0.05) 0%, rgba(255, 255, 255, 1) 100%)",
                borderRadius: "12px",
                boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
                border: "1.5px solid #1877F2",
                margin: "20px 0",
                fontFamily: "Arial, sans-serif",
                position: "relative",
                overflow: "hidden",
            }}
        >
            {/* Forecaster Name */}
            <div
                style={{
                    fontWeight: "bold",
                    fontSize: "16px",
                    marginBottom: "0px",
                    color: "#000",
                    borderBottom: "4px solid #1877F2",
                    padding: "10px",
                }}
            >
                <div style={{display: "flex", alignItems: "center"}}>
                    <div
                        style={{
                            width: "35px",
                            height: "35px",
                            borderRadius: "50%",
                            background: "#ddd",
                            marginRight: "8px",
                        }}
                    ></div>
                    <div
                        style={{
                            width: "120px",
                            height: "16px",
                            background: "#ddd",
                            borderRadius: "5px",
                        }}
                    ></div>
                </div>
            </div>

            {/* Content Skeleton */}
            <div style={{padding: "15px", display: "flex", flexDirection: "column", gap: "10px"}}>
                <div style={{display: "flex", justifyContent: "space-between"}}>
                    <div style={{width: "100px", height: "14px", background: "#ddd", borderRadius: "5px"}}></div>
                    <div style={{width: "60px", height: "14px", background: "#ddd", borderRadius: "5px"}}></div>
                </div>
                <div style={{display: "flex", justifyContent: "space-between"}}>
                    <div style={{width: "120px", height: "14px", background: "#ddd", borderRadius: "5px"}}></div>
                    <div style={{width: "80px", height: "14px", background: "#ddd", borderRadius: "5px"}}></div>
                </div>
                <div style={{width: "140px", height: "14px", background: "#ddd", borderRadius: "5px"}}></div>
            </div>
        </div>
    );
};

const SkeletonLoaderMobileList = () => {
    return (
        <>
            {[...Array(5)].map((_, index) => (
                <SkeletonLoaderMobile key={index} />
            ))}
        </>
    );
};

const MobileForecastCard = forwardRef(({data}, ref) => {
    return (
        <div
            ref={ref}
            style={{
                background: "linear-gradient(180deg, rgba(24, 119, 242, 0.05) 0%, rgba(255, 255, 255, 1) 100%)",
                borderRadius: "12px",
                boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
                border: "1.5px solid #1877F2",
                margin: "20px 0",
                fontFamily: "Arial, sans-serif",
                position: "relative",
                overflow: "hidden",
            }}
        >
            {/* Forecaster Name */}
            <div
                style={{
                    fontWeight: "bold",
                    fontSize: "16px",
                    marginBottom: "10px",
                    color: "#000",
                    borderBottom: "4px solid #1877F2",
                }}
            >
                <div
                    style={{
                        background:
                            "var(--try-gradient, linear-gradient(90deg, rgba(24, 119, 242, 0.17) 0.02%, rgba(24, 119, 242, 0.00) 123.27%))",
                        borderRadius: "20px",
                        padding: "8px 12px",
                        fontWeight: "bold",
                        color: "#000",
                        display: "flex",
                        justifyContent: "space-between",
                    }}
                >
                    <div style={{display: "flex", alignItems: "center"}}>
                        {" "}
                        <img
                            src={
                                data.photo &&
                                data.photo !==
                                    "https://crowdwisdom.live/wp-content/plugins/forcaster-accuracy-plugin/images/"
                                    ? data.photo
                                    : window.constants.asset_path + "/images/avtar.jpeg"
                            }
                            alt="Forecaster"
                            style={{width: "25px", height: "25px", borderRadius: "50%", marginRight: "2px"}} // Adjust size and shape as needed
                        />
                        {data.forecaster_name}
                    </div>

                    <div style={{display: "flex", alignItems: "center", gap: "3px"}}>
                        <img
                            src={`https://s2.coinmarketcap.com/static/img/coins/64x64/${data.cmc_id}.png`}
                            alt={data.slug}
                            style={{width: "22px", height: "22px"}}
                        />
                        <div>{data.slug}</div>
                    </div>
                </div>
            </div>

            {/* Info Rows */}
            <div
                style={{
                    display: "flex",
                    justifyContent: "space-between",
                    marginBottom: "12px",
                    marginLeft: "10px",
                    marginRight: "10px",
                }}
            >
                {/* Left Side */}
                <div style={{display: "flex", gap: "10px"}}>
                    <div style={{fontWeight: "bold", fontSize: "14px", color: "#000"}}>Target</div>
                    <div style={{fontSize: "14px", color: "#000"}}>{data.forecast_price}</div>
                </div>

                {/* Right Side */}
                <div style={{textAlign: "right", display: "flex", gap: "10px"}}>
                    <div style={{fontWeight: "bold", fontSize: "14px", color: "#000"}}>%Target Achieved</div>
                    <div style={{fontSize: "14px", color: "#000"}}>{data.target_percent}</div>
                </div>
            </div>

            <div
                style={{
                    display: "flex",
                    justifyContent: "space-between",
                    marginLeft: "10px",
                    marginRight: "10px",
                    marginBottom: "10px",
                }}
            >
                {/* Left Side */}
                <div style={{display: "flex", gap: "10px"}}>
                    <div style={{fontWeight: "bold", fontSize: "14px", color: "#000"}}>Past Accuracy</div>
                    <div style={{fontSize: "14px", color: "#000"}}>{data.accuracy}</div>
                </div>

                {/* Right Side */}
                <div style={{textAlign: "right", display: "flex", gap: "10px"}}>
                    <div style={{fontWeight: "bold", fontSize: "14px", color: "#000"}}>Date</div>
                    <div style={{fontSize: "14px", color: "#000"}}>{data.target_date}</div>
                </div>
            </div>
        </div>
    );
});

const CustomCheckbox = ({checked}) => {
    return (
        <div
            style={{
                width: "16px",
                height: "16px",
                borderRadius: "4px",
                border: "2px solid #007bff",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                backgroundColor: checked ? "#007bff" : "transparent",
            }}
        >
            {checked && (
                <svg width="12" height="12" viewBox="0 0 24 24" fill="none">
                    <path
                        d="M20 6L9 17l-5-5"
                        stroke="white"
                        strokeWidth="3"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </svg>
            )}
        </div>
    );
};

const CustomOption = (props) => {
    const {data, isSelected, innerRef, innerProps} = props;
    return (
        <div
            ref={innerRef}
            {...innerProps}
            style={{
                display: "flex",
                alignItems: "center",
                padding: "8px",
                cursor: "pointer",
                backgroundColor: isSelected ? "#e0f0ff" : "white",
                transition: "background 0.2s",
                "&:hover": {
                    backgroundColor: "#f0f0f0",
                },
            }}
        >
            <CustomCheckbox checked={isSelected} />
            <span style={{marginLeft: "8px"}}>{props.data.label}</span>
        </div>
    );
};

const drawerWidth = 292;
const TopPredictionsPage = (props) => {
    const {window1} = props;
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [searchTerm, setSearchTerm] = useState("");
    const [sortType, setSortType] = useState("fd_asc");
    const [sortDropdownVisible, setSortDropdownVisible] = useState(false);
    const [modalIsOpen, setModalIsOpen] = useState(false);
    const [modalData, setModalData] = useState(null);
    const [loader, setLoader] = useState(false);
    const [slug, setSlug] = useState(false);
    const [symbolLogo, setSymbolLogo] = useState(false);
    const [currentPrice, setCurrentPrice] = useState(false);
    const sortRef = useRef();
    const navigate = useNavigate();
    const [mobileOpen, setMobileOpen] = React.useState(false);
    const location = useLocation();
    const loc = location.pathname;
    const userData = JSON.parse(localStorage.getItem("cw_portfolio_user"));
    const [isLoginModalOpen, setLoginModalOpen] = useState(false);
    const [crypto, setCrypto] = useState("bitcoin");

    const [isEligible, setIsEligible] = useState();
    const [userPermission, setUserPermission] = useState(null);
    const [goToSubscribeAlertOpen, setGoToSubscribeAlertOpen] = useState(false);
    const [subscriptionText, setSubscriptionText] = useState("");
    const [predictionLoader, setPredictionLoader] = useState(false);
    const [data_replacements, setData_replacements] = useState([]);
    const [showModal, setShowModal] = useState(false); // Change the state name to showModal
    const [open, setOpen] = useState(false);
    const [Loading1, setLoading1] = useState(true);
    const [isPredictionDataLoaded, setIsPredictionDataLoaded] = useState(false);
    const [isTableView, setIsTableView] = useState(true);
    const [selectedButton, setSelectedButton] = useState("CoinPrices");
    const [paid_member, setpaid_member] = useState("no");
    const [unit, setUnit] = useState("");
    const [selectedOption, setSelectedOption] = useState([]);
    const [price, setPrice] = useState("");
    const [totalUnits, setTotalUnits] = useState(0);
    const [selectedDate, handleDateChange] = useState("");
    const [Usablewallet, setUsablewallet] = useState("");
    const [portfolioTypeId, setPortfolioTypeId] = useState("");
    const container = window1 !== undefined ? () => window1().document.body : undefined;
    const [showAlert, setShowAlert] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [severity, setSeverity] = useState("info");
    const [msgforUpdatePortfolio, setMsgforUpdatePortfolio] = useState("loading...");
    const handleClose = () => setOpen(false);
    const [isFormSubmitted, setIsFormSubmitted] = useState(false);
    const [dataslug, setdataslug] = useState("");
    const [options, setOptions] = useState([]);
    const [sortOrder, setSortOrder] = useState({
        // Track ascending/descending for each column
        forecaster: "asc",
        target: "asc",
        accuracy: "asc",
        percent: "asc",
        targetDate: "asc",
    });
    const [buySell, setbuySell] = React.useState("");
    const [isDialogOpen, setIsDialogOpen] = useState(false);
    const [newOptionValue, setNewOptionValue] = useState("");
    const [snackbaropen, setSnackbaropen] = React.useState(false);
    const [user_role, setuser_role] = useState("");
    const [slugpopupdata, setSlugpopupdata] = useState({
        slugname: "",
        slug: "",
        units: 0,
    });

    const [selectedFilter, setSelectedFilter] = useState(null);
    const handleModalClose = () => {
        setLoginModalOpen(false);
        navigate("/crypto-predictions/best-predictions", {replace: true});
    };
    useEffect(() => {
        const handleUserPermission = async () => {
            if (!userData?.user_id) return;
            try {
                setLoader(true);
                setLoading(true);
                const feature = BEST_PREDICTION_PAGE();
                const data = {
                    user_id: userData.user_id,
                    token: userData.token,
                    feature,
                };
                const response = await getUserAccessPermission(data);
                setUserPermission(response?.permission);
                setLoader(false);
            } catch (error) {
                console.error(error);
            }
        };

        handleUserPermission();
    }, [userData?.user_id]);

    const handleIsEligible = () => {
        if (userData && userPermission == "true") {
            setIsEligible(true);
            return;
        }
        setIsEligible(false);
        setLoading(false);
    };

    useEffect(() => {
        if (userPermission) {
            handleIsEligible();
        }
    }, [userPermission]);
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (sortRef.current && !sortRef.current.contains(event.target)) {
                setSortDropdownVisible(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    const mediaQueryVar = useMediaQuery(
        json2mq({
            minWidth: 900,
        })
    );

    const handleLoginClick = () => {
        console.log("checking", isEligible, userData);
        if (!userData) {
            console.log("checking", isEligible, userData);
            window.history.pushState({}, "", "/crypto-predictions/best-predictions");
            localStorage.setItem("isPopupManuallyOpened", "true");
            setLoginModalOpen(true);
        } else if (!isEligible) {
            setGoToSubscribeAlertOpen(true);
            setSubscriptionText(BEST_PREDICTION_MESSAGE());
        }
    };

    const handleDrawerToggle = () => {
        setMobileOpen(!mobileOpen);
    };

    const drawer = (
        <div className="d-flex flex-column h-100" style={{overflowY: "hidden"}}>
            <SidebarMenuList />
        </div>
    );

    const closeModal = () => {
        setModalIsOpen(false);
        setModalData(null);
    };

    const filteredData = data.filter((forecaster) =>
        forecaster.forecaster_name.toLowerCase().includes(searchTerm.toLowerCase())
    );

    const parseDate = (dateStr) => {
        const [month, day, year] = dateStr.split(" ");
        const monthMap = {
            Jan: "01",
            Feb: "02",
            Mar: "03",
            Apr: "04",
            May: "05",
            Jun: "06",
            Jul: "07",
            Aug: "08",
            Sep: "09",
            Oct: "10",
            Nov: "11",
            Dec: "12",
        };
        const formattedDate = `${year}-${monthMap[month]}-${day.padStart(2, "0")}`;
        return new Date(formattedDate);
    };

    const parseForecastPrice = (price) => {
        return parseFloat(price.replace(/[^0-9.-]+/g, ""));
    };

    const parseAccuracy = (accuracy) => {
        if (typeof accuracy !== "string") return NaN; // Return NaN if input is not a string

        // Extract the number from the accuracy string
        const percentage = accuracy.split("%")[0].trim(); // Get the part before '%'
        const parsedValue = parseFloat(percentage.split(" ")[0]); // Convert to float

        return isNaN(parsedValue) ? 0 : parsedValue; // Return 0 for NaN for safety
    };

    const compareValues = (val1, val2, order = "asc") => {
        // If either value is NaN, treat it as less than any valid number
        if (isNaN(val1) && isNaN(val2)) return 0; // Both are NaN
        if (isNaN(val1)) return 1; // Treat NaN as the largest value
        if (isNaN(val2)) return -1; // Treat NaN as the largest value

        // Perform comparison based on order
        if (order === "asc") return val1 - val2;
        return val2 - val1;
    };

    const handleSort = (column) => {
        const newSortOrder = sortOrder[column] === "asc" ? "desc" : "asc"; // Toggle sort order
        setSortOrder({...sortOrder, [column]: newSortOrder});

        // Set the sort type based on the column
        switch (column) {
            case "forecaster":
                setSortType(newSortOrder === "asc" ? "fc_asc" : "fc_desc");
                break;
            case "target":
                setSortType(newSortOrder === "asc" ? "tg_asc" : "tg_desc");
                break;
            case "accuracy":
                setSortType(newSortOrder === "asc" ? "ac_asc" : "ac_desc");
                break;
            case "percent":
                setSortType(newSortOrder === "asc" ? "pr_asc" : "pr_desc");
                break;
            case "targetDate":
                setSortType(newSortOrder === "asc" ? "fd_asc" : "fd_desc");
                break;
            default:
                break;
        }
    };

    const sortedData = [...filteredData].sort((a, b) => {
        switch (sortType) {
            case "fc_asc":
                return a.forecaster_name.localeCompare(b.forecaster_name);
            case "fc_desc":
                return b.forecaster_name.localeCompare(a.forecaster_name);
            case "tg_asc":
                return parseForecastPrice(a.forecast_price) - parseForecastPrice(b.forecast_price);
            case "tg_desc":
                return parseForecastPrice(b.forecast_price) - parseForecastPrice(a.forecast_price);
            case "ac_asc": {
                const accuracyA = parseAccuracy(a.accuracy);
                const accuracyB = parseAccuracy(b.accuracy);
                return compareValues(accuracyA, accuracyB, "asc");
            }
            case "ac_desc": {
                const accuracyA = parseAccuracy(a.accuracy);
                const accuracyB = parseAccuracy(b.accuracy);
                return compareValues(accuracyA, accuracyB, "desc");
            }
            case "pr_asc":
                return parseFloat(a.target_percent) - parseFloat(b.target_percent);
            case "pr_desc":
                return parseFloat(b.target_percent) - parseFloat(a.target_percent);
            case "fd_asc":
                return parseDate(a.target_date) - parseDate(b.target_date);
            case "fd_desc":
                return parseDate(b.target_date) - parseDate(a.target_date);
            default:
                return 0;
        }
    });

    useEffect(() => {
        if (sortedData && sortedData.length > 0 && !isPredictionDataLoaded) {
            setIsPredictionDataLoaded(true); // ✅ Only update if necessary
        }
    }, [sortedData, isPredictionDataLoaded]);

    const fetchDropdownOptions = async () => {
        const userData = JSON.parse(localStorage.getItem("cw_portfolio_user"));

        getFetchdropdown({
            user_id: userData.user_id,

            Token: userData.token,
        }).then((res) => {
            if (res.code === "200") {
                const newOptions = res.data.map((item) => ({
                    value: item.id,
                    label: item.name,
                }));
                setOptions(newOptions);
                setuser_role(res.user_role);
            } else {
                console.error("Data fething error");
            }
        });
    };

    const handleChange = async (selectedOption, slug) => {
        if (selectedOption && selectedOption._isNew_) {
            setIsDialogOpen(true);

            setSelectedOption(null);
            setdataslug(slug);
        } else if (!selectedOption) {
            // Handle the case when the selection is cleared
            setSelectedOption(null);
            setShowAlert(false);
            // Perform any other necessary actions
            return;
        } else {
            const selectedValue = selectedOption.value;
            if (selectedValue.includes("-")) {
                setErrorMessage("Hyphens are not allowed in the option."); // Set error message
                setShowAlert(true); // Show the alert
                return; // Abort further processing
            }
            setShowAlert(false);
            setSelectedOption(selectedOption);
            const userData = JSON.parse(localStorage.getItem("cw_portfolio_user"));
            getTotalunit({
                user_id: userData.user_id,
                slug: slug, // Assuming value contains the slug
                portfolio_type_id: selectedOption.value, // Adjust as needed
                Token: userData.token,
            }).then((res) => {
                if (res.code === "200") {
                    setTotalUnits(res.total_uint);
                    setUsablewallet(res.wallet_amount);
                } else {
                    console.error("Data fething error");
                }
            });
        }
    };

    useEffect(() => {
        if (open || showModal) {
            fetchDropdownOptions();
        }
    }, [open, showModal]);

    const handleCreate = async (inputValue) => {
        setTotalUnits(0);
        setUsablewallet("");

        if (options.find((option) => option.value === inputValue)) {
            return; // Exit early if the option already exists
        }
        const userData = JSON.parse(localStorage.getItem("cw_portfolio_user"));
        const newOption = {value: inputValue, label: inputValue};
        const newOptions = [...options, newOption]; // Create a new array with the existing options plus the new one
        setOptions(newOptions); // Update the options state
        const createdOption = newOptions.find((option) => option.value == inputValue);
        if (createdOption) {
            handleChange(createdOption);
        }
    };

    const formatToNonZero = (number) => {
        number = parseFloat(number);

        if (number >= 1) {
            return number.toFixed(2);
        } else if (number >= 0.1) {
            return number.toFixed(1);
        } else if (number >= 0.01) {
            return number.toFixed(4);
        } else if (number >= 0.001) {
            return number.toFixed(5);
        } else if (number >= 0.0001) {
            return number.toFixed(6);
        } else if (number >= 0.00001) {
            return number.toFixed(7);
        } else if (number >= 0.000001) {
            return number.toFixed(8);
        } else if (number >= 0.0000001) {
            return number.toFixed(9);
        } else if (number >= 0.00000001) {
            return number.toFixed(10);
        } else if (number >= 0.000000001) {
            return number.toFixed(11);
        }
        return number.toFixed(1);
    };

    const handleClick = (buySell) => {
        setSnackbaropen(true);
        setOpen(true);
        setSeverity("info");
        setIsFormSubmitted(false);
        setMsgforUpdatePortfolio("loading...");
        const userData = JSON.parse(localStorage.getItem("cw_portfolio_user"));
        const portfolioId =
            selectedOption && !isNaN(parseInt(selectedOption.value)) ? parseInt(selectedOption.value) : 0;
        const existingPortfolio = portfolioId > 0 ? "yes" : "no";

        addToPortfolio({
            portfolio_type_id: portfolioId,
            portfolio_name: selectedOption ? selectedOption.label : "",
            existing_portfolio: existingPortfolio,
            user_id: userData.user_id,
            slug: slugpopupdata.slugname,
            unit: unit,
            acquisition_price: price,
            date_time: selectedDate,
            type: buySell,
            Token: userData.token,
        }).then((res) => {
            if (res.code === "200") {
                // setOpen(false);
                setSeverity("info");
                setMsgforUpdatePortfolio(res.message);
                setPortfolioTypeId(res.portfolio_type_id);
                setIsFormSubmitted(true);
            } else {
                setSeverity("error");
                // setOpen(true)
                setMsgforUpdatePortfolio(res.message);
            }
        });
    };

    const handleDialogSubmit = () => {
        const newOption = {value: newOptionValue, label: newOptionValue};
        setOptions([...options, newOption]);
        setSelectedOption(newOption);
        setIsDialogOpen(false);

        const userData = JSON.parse(localStorage.getItem("cw_portfolio_user"));
        getTotalunit({
            user_id: userData.user_id,
            slug: dataslug,
            portfolio_type_id: newOption.value,
            Token: userData.token,
        }).then((res) => {
            if (res.code === "200") {
                setTotalUnits(res.total_uint);
                setNewOptionValue("");
                setUsablewallet(res.wallet_amount);
            } else {
                console.error("Data fething error");
            }
        });
    };

    const closesnackbar = (event, reason) => {
        if (reason === "clickaway") {
            return;
        }

        setSnackbaropen(false);
    };

    const handleChange2 = (e) => {
        const value = e.target.value;
        // Check if the input contains a hyphen
        if (value.includes("-")) {
            setShowAlert(true); // Show the alert if there's a hyphen
        } else {
            setShowAlert(false); // Hide the alert if there's no hyphen
            setNewOptionValue(value); // Update the state with the new value
        }
    };

    const [anchorEl, setAnchorEl] = useState(null);
    const openfilter = Boolean(anchorEl);

    const [selectedInfluencer, setSelectedInfluencer] = useState([]);
    const [selectedCrypto, setSelectedCrypto] = useState([]);

    const [selectedAccuracy, setSelectedAccuracy] = useState([]);
    const [selectedYear, setSelectedYear] = useState([]);

    const [forecasters, setForecasters] = useState([]);
    const [Cryptos, setCryptos] = useState([]);
    const [loadingMore, setLoadingMore] = useState(false);

    const accuracyOptions = ["<30%", "30-60%", ">60%"].map((item) => ({
        value: item,
        label: item,
    }));

    const yearOptions = ["2025", "2026", "2027", "2028", "2029", "2030"].map((item) => ({
        value: item,
        label: item,
    }));
    const [limit, setLimit] = useState(7);
    const [page, setPage] = useState(0);
    const dropdowns = [
        {
            label: mediaQueryVar ? "Influencer Name" : "Influencer",
            value: selectedInfluencer,
            setValue: setSelectedInfluencer,
            options: forecasters,
            width: mediaQueryVar ? "220px" : "150px",
            height: "40px",
        },
        {
            label: "Crypto",
            value: selectedCrypto,
            setValue: setSelectedCrypto,
            options: Cryptos,
            width: mediaQueryVar ? "170px" : "140px",
            height: "40px",
        },
        {
            label: "Accuracy",
            value: selectedAccuracy,
            setValue: setSelectedAccuracy,
            options: accuracyOptions,
            width: mediaQueryVar ? "170px" : "150px",
            height: "40px",
        },
        {
            label: "Year",
            value: selectedYear,
            setValue: setSelectedYear,
            options: yearOptions,
            width: mediaQueryVar ? "140px" : "140px",
            height: "40px",
        },
    ];

    const fetchDistinctCryptos = async () => {
        try {
            const response = await fetch("https://crowdwisdom.live/wp-json/api/v1/getDistinctCryptos");

            const result = await response.json();

            if (result.code === "200") {
                setCryptos(
                    result.data.map((item) => ({
                        value: item.name, // Assuming API response has "name"
                        label: item.name,
                        cmc_id: item.cmc_id, //Storing cmc_id

                        image: `https://s2.coinmarketcap.com/static/img/coins/64x64/${item.cmc_id}.png`,
                    }))
                );
            } else {
                setError(result.message);
            }
        } catch (err) {
            setError("An error occurred while fetching categories.");
        } finally {
            setLoading1(false);
        }
    };

    useEffect(() => {
        fetchDistinctCryptos();
        fetchDistinctInfluencers();
    }, []);

    const fetchDistinctInfluencers = async () => {
        try {
            const response = await fetch("https://crowdwisdom.live/wp-json/api/v1/getBestDistinctInfluencerNames", {
                method: "POST",
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded", // ✅ avoids preflight
                },
            });

            const result = await response.json();

            if (result.code === "200") {
                setForecasters(
                    result.data.map((item) => ({
                        value: item.name,
                        label: item.name,
                        image:
                            item.photo &&
                            item.photo !==
                                "https://crowdwisdom.live/wp-content/plugins/forcaster-accuracy-plugin/images/"
                                ? item.photo
                                : window.constants.asset_path + "/images/avtar.jpeg", // Corrected default avatar image
                    }))
                );
            } else {
                setError(result.message);
            }
        } catch (err) {
            setError("An error occurred while fetching categories.");
        } finally {
            setLoading1(false);
        }
    };

    const fetchData = async () => {
        const userData = JSON.parse(localStorage.getItem("cw_portfolio_user"));
        const userId = userData?.user_id || null;

        if (!isEligible) {
            setLoading(false);
            return;
        }
        try {
            if (page === 0) {
                setLoading(true);
            } else {
                setLoadingMore(true);
            }

            const params = new URLSearchParams();
            selectedCrypto.forEach((c) => params.append("searchVals[]", c.value));
            selectedInfluencer.forEach((i) => params.append("influencers[]", i.value));
            selectedAccuracy.forEach((a) => params.append("minAccuracy[]", a.value));
            selectedYear.forEach((y) => params.append("year[]", y.value));

            params.append("sortType", sortType);
            params.append("userId", userId);
            params.append("limit", 7);
            params.append("start_index", page * limit);

            const response = await fetch("https://crowdwisdom.live/wp-json/api/v1/showBestForecasterPredictions", {
                method: "POST",
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded", // No preflight
                },
                body: params.toString(),
            });

            const result = await response.json();

            if (result.code === "200") {
                if (result.response.length === 0 && result.response.length < limit) {
                    setPredictionLoader(true);
                }
                setSlug(result.symbol);
                setCurrentPrice(result.current_price);
                setSymbolLogo(result.symbol_logo);
                setData((pre) => [...pre, ...result.response]);
                setpaid_member(result.paid_member);
            } else {
                setError(result.message);
            }
        } catch (err) {
            setError("An error occurred while fetching data.");
        } finally {
            setLoading(false);
            setLoadingMore(false);
        }
    };

    useEffect(() => {
        if (isEligible === undefined) {
            return;
        }
        fetchData();
    }, [isEligible, selectedCrypto, selectedInfluencer, selectedAccuracy, selectedYear, page]);
    useEffect(() => {
        setPage(0);
        setData([]);
        setPredictionLoader(false);
    }, [selectedCrypto, selectedInfluencer, selectedAccuracy, selectedYear]);
    const SkeletonLoader = () => (
        <>
            {Array.from({length: 5}).map((_, index) => (
                <tr
                    key={index}
                    style={{
                        background: "#fff",
                        border: "1px solid #1877F2",
                        borderRadius: "10px",
                        marginBottom: "10px",
                        padding: "6px",
                        height: "60px",
                    }}
                >
                    {Array.from({length: 5}).map((_, idx) => (
                        <td
                            key={idx}
                            style={{
                                padding: "12px",
                                textAlign: "center",
                                fontSize: "14px",
                                border: "1px solid #1877F2",
                                borderRadius: idx === 0 ? "20px 0 0 20px" : idx === 4 ? "0 20px 20px 0" : "0",
                                borderLeft: idx === 0 ? "none" : "",
                                borderRight: idx === 4 ? "none" : "",
                            }}
                        >
                            <div className="skeleton-box" />
                        </td>
                    ))}
                </tr>
            ))}
        </>
    );

    const [visibleData, setVisibleData] = useState([]);
    const [rowCount, setRowCount] = useState(10);
    const observerRef = useRef(null);
    const lastRowRef = useRef(null);

    // useEffect(() => {
    //     if (sortedData.length > 0) {
    //         const newVisibleData = sortedData.slice(0, rowCount);

    //         if (JSON.stringify(newVisibleData) !== JSON.stringify(visibleData)) {
    //             setVisibleData(newVisibleData);
    //         }
    //     } else if (visibleData.length > 0) {
    //         setVisibleData([]); // Clear `visibleData` only if it's not already empty
    //     }
    // }, [sortedData, rowCount]); // ✅ Runs only when `sortedData` or `rowCount` changes

    const loadMoreRows = () => {
        setPage((prevPage) => prevPage + 1);
    };

    useEffect(() => {
        if (predictionLoader || loadingMore || loading) {
            return;
        }
        observerRef.current = new IntersectionObserver(
            (entries) => {
                if (entries[0].isIntersecting) {
                    setLoadingMore(true);
                    loadMoreRows();
                }
            },
            {rootMargin: "100px"} // ✅ Triggers before reaching bottom
        );

        if (lastRowRef.current) observerRef.current.observe(lastRowRef.current);
        return () => {
            if (observerRef.current) observerRef.current.disconnect();
        };
    }, [sortedData]);

    const [unreadAlerts, setUnreadAlerts] = useState(0);
    useEffect(() => {
        const userId = userData?.user_id || null;

        const fetchAlertsCount = async () => {
            try {
                const formData = new URLSearchParams();
                formData.append("user_id", userId); // convert to form-encoded format

                const response = await fetch("https://crowdwisdom.live/wp-json/api/v1/crypto_alerts_count", {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/x-www-form-urlencoded", // ✅ no preflight
                    },
                    body: formData, // ✅ correct format for this content type
                });

                if (!response.ok) {
                    throw new Error(`Error: ${response.status}`);
                }

                const data = await response.json();
                setUnreadAlerts(data.unread_notifications);
            } catch (error) {
                console.error("Failed to fetch alerts:", error);
            }
        };

        fetchAlertsCount();
    }, []);

    const [path, setPath] = useState("/");

    useEffect(() => {
        if (typeof window !== "undefined") {
            setPath(window.location.pathname);
        }
        if (!userData) {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        console.log("loading", loading);
    }, [loading]);

    const TopNavigationDesktop = ({unreadAlerts}) => {
        const isActive = (href) => path === href;

        const topTabStyle = (active) => ({
            display: "flex",
            alignItems: "center",
            padding: "4px 13px",
            borderRadius: "999px",
            backgroundColor: active ? "#ffffff" : "transparent",
            color: active ? "#1877F2" : "#ffffff",
            fontWeight: active ? "600" : "500",
            fontSize: "16px",
            cursor: "pointer",
            border: active ? "2px solid #ffffff" : "none",
        });

        const iconFilter = (active) =>
            active
                ? "invert(29%) sepia(98%) saturate(1502%) hue-rotate(189deg) brightness(100%) contrast(97%)"
                : "brightness(0) invert(1)";

        return (
            <div style={{padding: "20px", background: "#ffffff", boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)"}}>
                {/* Top Navigation */}
                <div
                    style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        margin: "0 auto",
                    }}
                >
                    {/* Left Tabs */}
                    <div
                        style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "8px",
                            backgroundColor: "#1877F2",
                            padding: "5px 5px",
                            borderRadius: "50px",
                        }}
                    >
                        {[tabLink["best_predictions"], tabLink["predict_now"], tabLink["screener"]].map(
                            (tab, index) => (
                                <Link to={tab.href} key={index} style={{textDecoration: "none", minWidth: "150px"}}>
                                    <div style={topTabStyle(isActive(tab.href))}>
                                        <img
                                            src={window?.constants?.asset_path + tab.icon}
                                            alt="icon"
                                            style={{
                                                marginRight: "6px",
                                                height: tab.icon_width || "25px",
                                                filter: iconFilter(isActive(tab.href)),
                                            }}
                                        />
                                        {!mediaQueryVar ? tab.mobile_name : tab.name}
                                    </div>
                                </Link>
                            )
                        )}
                    </div>
                    {/* Bottom Tabs */}
                    <BottomTab
                        tabs={[
                            tabLink["subscription"],
                            userData ? tabLink["my_portfolio"] : tabLink["presale"],
                            tabLink["profile"],
                        ]}
                        handleLoginClick={handleLoginClick}
                    />

                    {/* Notification Bell */}
                    <div
                        style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "flex-end",
                            gap: "5px",
                            marginRight: "15px",
                        }}
                    >
                        {/* Notification Bell */}
                        <div
                            onClick={() => (window.location.href = "/alerts")}
                            style={{position: "relative", cursor: "pointer"}}
                        >
                            <NotificationIcon className="notification-icon fa-2x" />
                            {/* Desktop */}
                            <div
                                style={{
                                    position: "absolute",
                                    top: "-6px",
                                    right: "2px",
                                    backgroundColor: "#c0392b",
                                    minWidth: unreadAlerts < 100 ? "20px" : "27px",
                                    height: unreadAlerts < 100 ? "20px" : "27px",
                                    borderRadius: "50%",
                                    fontSize: "11px",
                                    color: "#fff",
                                    textAlign: "center",
                                    lineHeight: "20px",
                                    fontWeight: "bold",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    padding: "0 4px",
                                }}
                            >
                                {unreadAlerts < 100 ? unreadAlerts : "99+"}
                            </div>
                        </div>

                        <UserAvatar />
                    </div>
                </div>
            </div>
        );
    };
    const TopNavigationMobile = ({unreadAlerts}) => {
        const isActive = (href) => path === href;

        const topTabStyle = (active) => ({
            display: "flex",
            alignItems: "center",
            padding: active ? "3px 6px" : "1px 6px",
            borderRadius: "999px",
            backgroundColor: active ? "#ffffff" : "transparent",
            textAlign: "left",
            color: active ? "#000" : "#ffffff",
            fontWeight: active ? "600" : "500",
            fontSize: "12px",
            cursor: "pointer",
            border: active ? "2px solid #ffffff" : "none",
        });

        const iconFilter = (active) =>
            active
                ? "invert(29%) sepia(98%) saturate(1502%) hue-rotate(189deg) brightness(100%) contrast(97%)"
                : "brightness(0) invert(1)";

        return (
            <div style={{padding: "10px 5px", background: "#ffffff", boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)"}}>
                {/* Top Navigation */}
                <div
                    style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        margin: 0,
                    }}
                >
                    {/* Left Tabs */}
                    <div
                        style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "0px",
                            backgroundColor: "#1877F2",
                            padding: "5px 5px",
                            borderRadius: "50px",
                            fontSize: "13px",
                            minWidth: "200px",
                            textAlign: "center",
                            marginRight: "10px",
                        }}
                    >
                        {[tabLink["best_predictions"], tabLink["predict_now"]].map((tab, index) => (
                            <Link to={tab.href} key={index} style={{textDecoration: "none"}}>
                                <div style={topTabStyle(isActive(tab.href))}>
                                    <img
                                        src={window?.constants?.asset_path + tab.icon}
                                        alt="icon"
                                        style={{
                                            marginRight: "6px",
                                            height: tab.icon_width || "25px",
                                            filter: iconFilter(isActive(tab.href)),
                                        }}
                                    />
                                    {tab.name}
                                </div>
                            </Link>
                        ))}
                    </div>

                    <div style={{display: "flex", alignItems: "center"}}>
                        {/* Notification Bell */}
                        <div
                            onClick={() => (window.location.href = "/alerts")}
                            style={{position: "relative", marginTop: "3px"}}
                        >
                            <NotificationIcon className="notification-icon fa-2x" />
                            {/* Mobile */}
                            <div
                                style={{
                                    position: "absolute",
                                    top: "-5px",
                                    right: "7px",
                                    backgroundColor: "#c0392b",
                                    minWidth: unreadAlerts < 100 ? "18px" : "24px",
                                    height: unreadAlerts < 100 ? "18px" : "24px",
                                    borderRadius: "50%",
                                    fontSize: "10px",
                                    color: "#fff",
                                    textAlign: "center",
                                    lineHeight: "18px",
                                    fontWeight: "bold",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    padding: "0 4px",
                                }}
                            >
                                {unreadAlerts < 100 ? unreadAlerts : "99+"}
                            </div>
                        </div>
                        <UserAvatar />
                        <IconButton
                            color="inherit"
                            aria-label="open drawer"
                            edge="end"
                            onClick={handleDrawerToggle}
                            sx={{display: {sm: "none"}}}
                        >
                            <img
                                src="/images/menubar.svg"
                                alt="Menu Icon"
                                style={{
                                    width: "24px",
                                    height: "24px",
                                    marginRight: "10px",
                                    marginTop: "10px",
                                }}
                            />
                        </IconButton>
                    </div>
                </div>

                {/* Bottom Tabs */}
                <div
                    style={{
                        display: "flex",
                        justifyContent: "flex-start",
                        gap: "10px",
                        marginTop: "25px",
                        marginRight: "10px",
                    }}
                >
                    <BottomTab
                        tabs={[
                            tabLink["subscription"],
                            userData ? tabLink["my_portfolio"] : tabLink["presale"],
                            tabLink["profile"],
                        ]}
                        handleLoginClick={handleLoginClick}
                    />
                </div>
            </div>
        );
    };

    return (
        <div
            className="crypto-page"
            style={{
                padding: mediaQueryVar ? 0 : "10px",
                margin: 0,
                backgroundColor: mediaQueryVar ? "#F2F2F2" : "#fff",
            }}
        >
            <Helmet>
                <title>Best Crypto Influencer Price Predictions</title>
                <meta
                    name="description"
                    content={`Accurate ${
                        crypto.charAt(0).toUpperCase() + crypto.slice(1)
                    } Influencer Price Predictions & In-depth ${
                        crypto.charAt(0).toUpperCase() + crypto.slice(1)
                    } Price Predictions.`}
                />
            </Helmet>

            <Modal
                isOpen={open}
                onRequestClose={handleClose}
                overlayClassName={{
                    overlay: {
                        backgroundColor: "rgba(0, 0, 0, 0.5)", // Semi-transparent black overlay
                        backdropFilter: "blur(5px)", // Optional: Add a blur effect to the overlay
                    },
                }}
                className={{
                    content: {
                        position: "relative",
                        backgroundColor: "white", // Set background for inner popup
                        padding: "20px", // Add padding for content
                        borderRadius: "8px", // Rounded corners
                        maxWidth: mediaQueryVar ? "100%" : "100%", // Set a max width for popup
                        margin: "0", // Center the popup horizontally
                        boxShadow: "0px 4px 16px rgba(0, 0, 0, 0.2)", // Optional: Popup shadow
                    },
                }}
            >
                <div className="CardOpener" style={{overflow: "hidden"}}>
                    {isFormSubmitted ? (
                        <div
                            style={{
                                position: "fixed", // Fix the popup to the top of the viewport
                                top: 0, // Align it to the top
                                left: 0,
                                width: "100%",
                                height: "100vh",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                backgroundColor: "rgba(0, 0, 0, 0.5)", // Optional: darken the background for emphasis
                                zIndex: 1000, // High z-index to overlay other elements
                            }}
                        >
                            <Card className="card__container">
                                <div
                                    style={{
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        flexDirection: "column",
                                    }}
                                >
                                    <div
                                        style={{
                                            display: "flex",
                                            justifyContent: "center",
                                            alignItems: "center",
                                        }}
                                    >
                                        <CheckCircleOutlineIcon sx={{fontSize: 50, mr: 1}} />
                                    </div>
                                    <Typography
                                        severity="success"
                                        sx={{
                                            display: "flex",
                                            justifyContent: "center",
                                            alignItems: "center",
                                        }}
                                    >
                                        Portfolio added successfully!
                                    </Typography>
                                    <div
                                        style={{
                                            display: "flex",
                                            justifyContent: "space-evenly",
                                            marginTop: "10px",
                                            width: "100%",
                                        }}
                                    >
                                        <Button
                                            onClick={() => {
                                                setIsFormSubmitted(false);
                                                setOpen(false);
                                                setUnit("");
                                                setSelectedOption("");
                                                setPrice("");
                                                setTotalUnits(0);
                                                handleDateChange("");
                                                setUsablewallet("");
                                            }}
                                            color="primary"
                                            style={{
                                                backgroundColor: "rgba(67, 97, 238, 0.15)",
                                                borderRadius: "6px",
                                                border: "none",
                                                textTransform: "none",
                                                borderStyle: "solid",
                                                borderColor: "rgba(67, 97, 238, 0.15)",
                                                borderWidth: "1px",
                                                color: "#4361ee",
                                                whiteSpace: "nowrap",
                                                float: "inline-end",
                                                width: mediaQueryVar === true ? "150px" : "100px",
                                                height: mediaQueryVar === false ? "30px" : "",
                                                fontSize: mediaQueryVar === false ? "10px" : "11px",
                                            }}
                                        >
                                            Add More Cryptos
                                        </Button>
                                        <Button
                                            onClick={() =>
                                                navigate(
                                                    `/my-portfolio/${portfolioTypeId}/${encodeURIComponent(
                                                        selectedOption.label.replace(/\s+/g, "-")
                                                    )}`
                                                )
                                            }
                                            variant="outlined"
                                            style={{
                                                backgroundColor: "rgba(67, 97, 238, 0.15)",
                                                borderRadius: "6px",
                                                border: "none",
                                                textTransform: "none",
                                                borderStyle: "solid",
                                                borderColor: "rgba(67, 97, 238, 0.15)",
                                                borderWidth: "1px",
                                                color: "#4361ee",
                                                whiteSpace: "nowrap",
                                                float: "inline-end",
                                                width: mediaQueryVar === true ? "100px" : "100px",
                                                height: mediaQueryVar === false ? "30px" : "",
                                                fontSize: mediaQueryVar === false ? "10px" : "11px",
                                            }}
                                            color="primary"
                                        >
                                            View Portfolio
                                        </Button>
                                    </div>
                                </div>
                            </Card>
                        </div>
                    ) : (
                        <Dialog
                            PaperProps={{
                                sx: {
                                    position: mediaQueryVar ? "static" : "fixed",
                                    bottom: mediaQueryVar ? "" : 0,
                                    left: mediaQueryVar ? "" : 0,
                                    right: mediaQueryVar ? "" : 0,
                                    marginLeft: mediaQueryVar ? "" : "0px",
                                    marginRight: mediaQueryVar ? "" : "0px",
                                    marginTop: "1%",
                                    maxWidth: "100%",
                                    minHeight: mediaQueryVar ? "60%" : "", // Adjust max height if needed
                                    borderRadius: mediaQueryVar ? "24px" : "24px 24px 0 0",
                                    marginBottom: mediaQueryVar ? "" : "0px",
                                    padding: mediaQueryVar ? "10px" : "1px",
                                    alignItems: "center",
                                    overflow: "scroll",
                                    "&::-webkit-scrollbar": {
                                        display: "none",
                                    },
                                    "-ms-overflow-style": "none",
                                    "scrollbar-width": "none", // Ensure no scrollbar
                                },
                            }}
                            open={open}
                            onClose={handleClose}
                        >
                            <div
                                style={{
                                    padding: "20px",
                                    width: mediaQueryVar ? "400px" : "100%",
                                    margin: "0",
                                    marginTop: "-5px",
                                }}
                            >
                                <div
                                    style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        alignItems: "center",
                                        marginBottom: "20px",
                                        borderBottom: "1px #E3E3E3 solid",
                                    }}
                                >
                                    <Typography
                                        style={{
                                            fontWeight: "500",
                                            fontSize: "20.767px",
                                            paddingLeft: "100px",
                                        }}
                                        gutterBottom
                                    >
                                        Add To Portfolio
                                    </Typography>

                                    <div className="primaryButton">
                                        <img
                                            className="frameIcon"
                                            alt=""
                                            onClick={handleClose}
                                            src={window.constants.asset_path + "/images/frame17.svg"}
                                            style={{
                                                background: "#F3F3F3",
                                                width: "25px",
                                                height: "25px",
                                            }}
                                        />
                                    </div>
                                </div>
                                <div
                                    style={{
                                        display: "flex",
                                        flexDirection: "column",
                                        marginBottom: "5px",
                                        marginLeft: mediaQueryVar === false ? "10px" : "",
                                    }}
                                >
                                    <Typography
                                        style={{
                                            fontSize: "13.845px",
                                            fontWeight: "500",
                                            marginBottom: "1px",
                                            color: "black",
                                            marginTop: "-8px",
                                        }}
                                    >
                                        Select Portfolio
                                    </Typography>
                                    <div style={{marginTop: "5px"}}>
                                        <CreatableSelect
                                            isClearable
                                            styles={{
                                                control: (provided) => ({
                                                    ...provided,
                                                    borderRadius: "12px",
                                                    border: "1px solid #1877F2",
                                                    boxShadow: "none",
                                                    minHeight: "40px",
                                                    "&:hover": {
                                                        borderRadius: "12px",
                                                        border: "2px solid #1877F2",
                                                    },
                                                }),
                                                menu: (provided) => ({
                                                    ...provided,
                                                    borderRadius: "8px",
                                                }),
                                                placeholder: (provided) => ({
                                                    ...provided,
                                                    color: "",
                                                }),
                                                dropdownIndicator: (provided) => ({
                                                    ...provided,
                                                    color: "#1877F2",
                                                    border: "1px solid #1877F2",
                                                    padding: "5px",
                                                    margin: "8px",
                                                    borderRadius: "3.786px",
                                                    "&:hover": {
                                                        color: "#1877F2",
                                                    },
                                                }),
                                                indicatorSeparator: (provided) => ({
                                                    display: "none",
                                                }),
                                            }}
                                            placeholder=""
                                            onChange={(options) => handleChange(options, slugpopupdata.slugname)}
                                            onCreateOption={handleCreate}
                                            options={[
                                                {
                                                    value: "",
                                                    label: "Create new portfolio",
                                                    _isNew_: true,
                                                }, // Dynamic "create new option" item
                                                ...options, // Existing options
                                            ]}
                                            value={selectedOption}
                                        />
                                    </div>
                                    {showAlert && (
                                        <Alert severity="error" sx={{marginBottom: "10px"}}>
                                            {errorMessage}
                                        </Alert>
                                    )}
                                </div>
                                <Typography
                                    style={{
                                        fontSize: "13.845px",
                                        fontWeight: "500",
                                        color: "#000",
                                        marginTop: "10px",
                                        marginBottom: "5px",
                                    }}
                                >
                                    Usable Wallet Value: {Usablewallet}
                                </Typography>
                                <div
                                    style={{
                                        padding: mediaQueryVar ? "8px" : "5px",
                                        background: "#F3F3F3",
                                        borderRadius: "8px",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "space-between",
                                        marginBottom: "5px",
                                    }}
                                >
                                    <div
                                        style={{
                                            display: "flex",
                                            alignItems: "center",
                                            flex: 0,
                                            minWidth: 0,
                                        }}
                                    >
                                        <img
                                            style={{
                                                marginRight: "10px",
                                                border: "2px solid #000",
                                                borderRadius: "19px",
                                                height: "27.69px",
                                                width: "27.69px",
                                            }}
                                            alt=""
                                            src={slugpopupdata.logo}
                                        />
                                        <div style={{display: "flex", flexDirection: "column"}}>
                                            <Typography
                                                sx={{
                                                    fontWeight: "500",
                                                    marginBottom: "0px",
                                                    fontSize: "14px",
                                                    color: "#7F7F80",
                                                }}
                                            >
                                                {slugpopupdata.slugname}
                                            </Typography>
                                        </div>
                                    </div>
                                    <div
                                        style={{
                                            display: "flex",
                                            flexDirection: "column",
                                            alignItems: "center",
                                            marginLeft: "20%",
                                            flex: 1,
                                        }}
                                    >
                                        <Typography
                                            sx={{
                                                fontWeight: "500",
                                                marginBottom: "4px",
                                                fontSize: "13px",
                                                color: "#7F7F80",
                                            }}
                                        >
                                            {" "}
                                            Price
                                        </Typography>
                                        <Typography
                                            sx={{
                                                fontSize: "12.114px",
                                                fontWeight: "500",
                                                color: "black",
                                                margin: "0",
                                                marginLeft: "5%",
                                            }}
                                        >
                                            {slugpopupdata.pricetoday}
                                        </Typography>
                                    </div>
                                    <div
                                        style={{
                                            display: "flex",
                                            flexDirection: "column",
                                            alignItems: "center",
                                            marginLeft: "20px",
                                        }}
                                    >
                                        <Typography
                                            sx={{
                                                fontWeight: "500",
                                                marginBottom: "4px",
                                                fontSize: "13px",
                                                color: "#7F7F80",
                                            }}
                                        >
                                            {" "}
                                            Units
                                        </Typography>
                                        <Typography
                                            sx={{
                                                fontSize: "12.114px",
                                                fontWeight: "500",
                                                color: "black",
                                                margin: "0",
                                            }}
                                        >
                                            {totalUnits}
                                        </Typography>
                                    </div>
                                </div>
                                <div className="card__container__row3">
                                    <div style={{marginLeft: "-5px"}}>
                                        <p style={{fontSize: "14px", fontWeight: "500"}}>Enter number of Units</p>
                                        <input
                                            style={{
                                                backgroundColor: "white",
                                                color: "black",
                                                padding: "20px",
                                                border: "1px solid #1877F2",
                                                borderRadius: "10.384px",
                                                width: mediaQueryVar ? "350px" : "100%",
                                                height: "45px",
                                                margin: 0,
                                            }}
                                            min="1"
                                            max="10"
                                            type="number"
                                            placeholder=""
                                            value={unit}
                                            onChange={(e) => setUnit(e.target.value)}
                                        ></input>
                                    </div>
                                    <div>
                                        $
                                        {formatToNonZero(
                                            unit *
                                                parseFloat(
                                                    (slugpopupdata.pricetoday || "")
                                                    .replace(/^\$/, "") // Remove the dollar sign
                                                    .replace(/,/g, "") // Remove commas
                                                )
                                        )}
                                    </div>
                                    {user_role === "superuser" && (
                                        <>
                                            <div className="card__container__row3__r2">
                                                <div style={{marginLeft: "-5px"}}>
                                                    <p style={{fontSize: "14px", fontWeight: "500"}}>
                                                        Buy/Sell Price($)
                                                    </p>
                                                    <input
                                                        style={{
                                                            backgroundColor: "white",
                                                            color: "black",
                                                            padding: "20px",
                                                            border: "1px solid #1877F2",
                                                            borderRadius: "10.384px",
                                                            width: "345px",
                                                            height: "45px",
                                                        }}
                                                        className="card__container__row3__r2__input"
                                                        min="1"
                                                        max="10"
                                                        type="number"
                                                        placeholder="Enter Price"
                                                        value={price}
                                                        onChange={(e) => setPrice(e.target.value)}
                                                    ></input>
                                                </div>
                                            </div>
                                            <div style={{marginBottom: "10px", marginLeft: "-5px"}}>
                                                <p style={{fontSize: "14px", fontWeight: "500"}}>Date</p>
                                                <TextField
                                                    type="date"
                                                    value={selectedDate}
                                                    onChange={(e) => handleDateChange(e.target.value)}
                                                    InputLabelProps={{
                                                        shrink: true,
                                                    }}
                                                    sx={{
                                                        "& .MuiOutlinedInput-root": {
                                                            borderRadius: "10.384px",
                                                            border: "1px solid #1877F2",
                                                            boxShadow: "none",
                                                            width: "190%",
                                                            height: "45px",
                                                        },
                                                    }}
                                                />
                                            </div>
                                        </>
                                    )}
                                    <div className="card__container__row3__r4" style={{marginTop: "10px"}}>
                                        <Button
                                            className={buySell === "buy" ? "buttonToggleButActive" : "buttonToggleBuy"}
                                            value="Buy"
                                            style={{
                                                lineHeight: "20px",
                                                width: mediaQueryVar ? "159px" : "130px",
                                                borderRadius: "27px",
                                                border: "1px solid #1877F2",
                                                padding: mediaQueryVar ? "15px 85px" : "13px 75px",
                                                marginLeft: "-6px",
                                                backgroundColor: buySell === "buy" ? "" : "#1877F2",
                                                color: buySell === "buy" ? "" : "white",
                                                textTransform: "none",
                                                fontSize: "18px",
                                                fontWeight: "700",
                                            }}
                                            onClick={() => handleClick("buy")}
                                        >
                                            Buy
                                        </Button>
                                        <Button
                                            className={
                                                buySell === "sell" ? "buttonToggleSellActive" : "buttonToggleSell"
                                            }
                                            value="sell"
                                            style={{
                                                lineHeight: "20px",
                                                width: mediaQueryVar ? "159px" : "130px",
                                                borderRadius: "27px",
                                                border: "1px solid #1877F2",
                                                marginLeft: "10px",
                                                padding: mediaQueryVar ? "15px 85px" : "13px 75px",
                                                backgroundColor: buySell === "sell" ? "" : "#1877F2",
                                                color: buySell === "sell" ? "" : "white",
                                                textTransform: "none",
                                                fontSize: "18px",
                                                fontWeight: "700",
                                            }}
                                            onClick={() => handleClick("sell")}
                                        >
                                            Sell
                                        </Button>
                                    </div>
                                </div>
                            </div>
                        </Dialog>
                    )}
                </div>
            </Modal>

            <Dialog open={isDialogOpen} onClose={() => setIsDialogOpen(false)} fullWidth maxWidth="sm">
                <DialogTitle>
                    Create New Portfolio
                    <IconButton
                        aria-label="close"
                        onClick={() => {
                            setIsDialogOpen(false);
                            setNewOptionValue("");
                        }}
                        sx={{position: "absolute", right: 13, top: 8}}
                    >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent>
                    <div>
                        <TextField
                            autoFocus
                            label="Enter Name"
                            value={newOptionValue}
                            onChange={handleChange2}
                            fullWidth
                            margin="dense"
                        />
                        {showAlert && (
                            <Alert severity="error" sx={{marginTop: "8px"}}>
                                Hyphens are not allowed in the name.
                            </Alert>
                        )}
                    </div>
                </DialogContent>
                <DialogActions sx={{marginRight: "14px"}}>
                    <Button
                        onClick={() => {
                            setIsDialogOpen(false);
                            setNewOptionValue("");
                        }}
                        sx={{fontWeight: "bold"}}
                        variant="outlined"
                        color="primary"
                    >
                        Cancel
                    </Button>
                    <Button
                        onClick={handleDialogSubmit}
                        variant="contained"
                        color="primary"
                        sx={{fontWeight: "bold"}}
                        disabled={!newOptionValue.trim()}
                    >
                        Submit
                    </Button>
                </DialogActions>
            </Dialog>

            <Snackbar
                open={snackbaropen}
                autoHideDuration={5000}
                onClose={closesnackbar}
                anchorOrigin={{vertical: "bottom", horizontal: "center"}}
            >
                <Alert severity={severity}>{msgforUpdatePortfolio}</Alert>
            </Snackbar>

            <Drawer
                container={container}
                variant="temporary"
                open={mobileOpen}
                onClose={handleDrawerToggle}
                ModalProps={{
                    keepMounted: true, // Better open performance on mobile.
                }}
                sx={{
                    display: {xs: "block", sm: "none"},
                    "& .MuiDrawer-paper": {
                        boxSizing: "border-box",
                        width: drawerWidth,
                        backgroundColor: "white",
                        color: "#727376",
                    },
                }}
            >
                {drawer}
            </Drawer>

            {/* Filters Code */}
            {/* <Box
                        sx={{
                          borderRadius: "10px",
                          display: "flex",
                          justifyContent: "flex-end",
                          marginBottom: "0px",
                          color:"#1877F2",
                          marginLeft:"-10px"
                        }}
                      >
                        <Button
                          onClick={handlePopoverOpen}
                        >
                          
                          <div style={{
                          padding:"6px 2px"
                          }}>
                          <img width="23px"
                          src={window.constants.asset_path + '/images/filter2.svg'}/></div>
                        </Button>
            
                        <Popover
                          open={openfilter}
                          anchorEl={anchorEl}
                          onClose={handleCloseeoption}
                          anchorOrigin={{
                            vertical: "bottom",
                            horizontal: "center",
                          }}
                          transformOrigin={{
                            vertical: "top",
                            horizontal: "center",
                          }}
                          style={{
                           
                          }}
                        >
                         <MenuItem
                            selected={selectedFilter === "fc_asc"}
                            onClick={() => handleSort("forecaster")}
                          >
                           Forecaster {sortOrder.forecaster === "asc" ? "↑" : "↓"}
                          </MenuItem>
                          
                          <MenuItem
                            selected={selectedFilter === "tg_asc"}
                            onClick={() => handleSort("target")}
                          >
                            Target {sortOrder.target === "asc" ? "↑" : "↓"}
                          </MenuItem>
                          <MenuItem
                            selected={selectedFilter === "ac_asc"}
                            onClick={() => handleSort("accuracy")}
                          >
                            Accuracy {sortOrder.accuracy === "asc" ? "↑" : "↓"}
                          </MenuItem>
                          
            
                          <MenuItem
                            selected={selectedFilter === "pr_asc"}
                            onClick={() => handleSort("percent")}
                          >
                            Achieved  {sortOrder.percent === "asc" ? "↑" : "↓"}
                          </MenuItem>
                          <MenuItem
                            selected={selectedFilter === "fd_asc"}
                            onClick={() => handleSort("targetDate")}
                          >
                            Target Date {sortOrder.targetDate === "asc" ? "↑" : "↓"}
                          </MenuItem>
                
      
                          <Box sx={{ display: "flex", padding: "8px" }}>
                            <Button
                              size="small"
                              sx={{ textTransform: "capitalize", marginLeft: "10px" }}
                              onClick={handleClearAll}
                              startIcon={<ClearIcon />}
                            >
                              Clear All
                            </Button>
                          </Box>
                        </Popover>
            
                        
        </Box> */}

            {mediaQueryVar ? (
                <div className="layout">
                    <div className>
                        <Box
                            component="nav"
                            sx={{width: {sm: drawerWidth}, flexShrink: {sm: 0}}}
                            aria-label="mailbox folders"
                        >
                            {/* The implementation can be swapped with js to avoid SEO duplication of links. */}
                            <Drawer
                                container={container}
                                variant="temporary"
                                open={mobileOpen}
                                onClose={handleDrawerToggle}
                                ModalProps={{
                                    keepMounted: true, // Better open performance on mobile.
                                }}
                                sx={{
                                    display: {xs: "block", sm: "none"},
                                    "& .MuiDrawer-paper": {
                                        boxSizing: "border-box",
                                        width: drawerWidth,
                                        backgroundColor: "white",
                                        color: "#727376",
                                    },
                                }}
                            >
                                {drawer}
                            </Drawer>
                            <Drawer
                                variant="permanent"
                                sx={{
                                    display: {xs: "none", sm: "block"},
                                    "& .MuiDrawer-paper": {
                                        boxSizing: "border-box",
                                        width: drawerWidth,
                                        backgroundColor: "white",
                                        color: "#727376",
                                    },
                                }}
                                open
                            >
                                {drawer}
                            </Drawer>
                        </Box>
                    </div>

                    <div
                        style={{
                            position: "fixed",
                            top: 0,
                            left: drawerWidth,
                            width: `calc(100% - ${drawerWidth}px)`,
                            backgroundColor: "#ffffff",
                            zIndex: 1000,
                            boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                            height: "100px", // You may need to increase this if banner + nav exceeds 100px
                            display: "flex",
                            flexDirection: "column",
                        }}
                    >
                        <PromoBanner />
                        <TopNavigationDesktop unreadAlerts={unreadAlerts} />
                    </div>

                    <div
                        className="content"
                        style={{
                            margin: "0%",
                            padding: "10px",
                            paddingTop: mediaQueryVar ? "200px" : "300px",
                        }}
                    >
                        <div>
                            {/* Multi-Select Dropdowns */}
                            <div
                                style={{
                                    display: "flex",
                                    justifyContent: "center",
                                    gap: "30px",
                                    padding: "10px",
                                    color: "black",
                                }}
                            >
                                {dropdowns.map((dropdown, index) => (
                                    <div key={index} style={{width: dropdown.width, height: dropdown.height}}>
                                        <Select
                                            options={dropdown.options}
                                            isMulti
                                            placeholder={dropdown.label}
                                            value={dropdown.value} // The selected values
                                            onChange={(selectedOptions) => {
                                                dropdown.setValue(selectedOptions);
                                            }}
                                            closeMenuOnSelect={false} // Keep dropdown open
                                            hideSelectedOptions={false} // Keep selected options in the list
                                            styles={{
                                                dropdownIndicator: (base) => ({
                                                    ...base,
                                                    color: "black",
                                                }),
                                                indicatorSeparator: (base) => ({
                                                    ...base,
                                                    display: "none",
                                                }),
                                                control: (base) => ({
                                                    ...base,
                                                    background:
                                                        "linear-gradient(91deg, #9AFFF9 18.86%, #FFF06D 100.02%)",
                                                    border: "2px solid #79A7FF",
                                                    borderRadius: "10px",
                                                    padding: "2px",
                                                    fontSize: "14px",
                                                    fontWeight: "bold",
                                                    color: "#000",
                                                    cursor: "pointer",
                                                }),
                                                menu: (base) => ({
                                                    ...base,
                                                    background: "#fff",
                                                    borderRadius: "10px",
                                                    boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
                                                    color: "#000",
                                                }),
                                                multiValue: (base) => ({
                                                    ...base,
                                                    display: "none", // Hide selected values inside the input field
                                                }),
                                                valueContainer: (base, state) => {
                                                    const showLabel = !state.selectProps.inputValue; // Hide label while typing

                                                    return {
                                                        ...base,
                                                        padding: "4px",
                                                        position: "relative",
                                                        ":before": showLabel
                                                            ? {
                                                                  content: `"${dropdown.label}"`,
                                                                  color: "#000",
                                                                  fontWeight: "bold",
                                                                  fontSize: "14px",
                                                                  position: "absolute",
                                                                  left: "10px",
                                                                  top: "50%",
                                                                  transform: "translateY(-50%)",
                                                              }
                                                            : {},
                                                    };
                                                },
                                                placeholder: (base) => ({
                                                    ...base,
                                                    display: "none", // Hide default placeholder since we use :before
                                                }),
                                            }}
                                            components={{Option: CustomOption}}
                                        />
                                    </div>
                                ))}
                            </div>

                            {/* Selected Filters */}
                            <div
                                style={{display: "flex", flexWrap: "wrap", justifyContent: "center", marginTop: "15px"}}
                            >
                                {dropdowns.map((dropdown, index) =>
                                    dropdown.value.map((item) => (
                                        <div
                                            key={`${index}-${item.value}`}
                                            style={{
                                                display: "flex",
                                                alignItems: "center",
                                                backgroundColor: "#fff",
                                                color: "#000",
                                                borderRadius: "10px",
                                                padding: "5px 10px",
                                                margin: "5px",
                                                fontWeight: "bold",
                                                border: "1px solid #1877F2",
                                            }}
                                        >
                                            {(dropdown.label === "Crypto" || dropdown.label === "Influencer Name") &&
                                                item.image && (
                                                    <img
                                                        src={
                                                            item.image?.trim()
                                                                ? item.image
                                                                : window.constants.asset_path + "/images/avtar.jpeg"
                                                        }
                                                        alt={item.label}
                                                        style={{
                                                            width: "30px",
                                                            height: "30px",
                                                            marginRight: "8px",
                                                            borderRadius: "50%",
                                                        }}
                                                    />
                                                )}

                                            {item.label}
                                        </div>
                                    ))
                                )}
                            </div>
                        </div>

                        <div
                            style={{
                                padding: "15px 15px",
                                fontFamily: "Satoshi, sans-serif",
                                margin: "15px 5px",
                            }}
                        >
                            <style>
                                {`
                                    @keyframes shimmer {
                                    0% { background-position: -200px 0; }
                                    100% { background-position: 200px 0; }
                                    }
                                    .skeleton-box {
                                    width: 80%;
                                    height: 20px;
                                    background: linear-gradient(90deg, #e0e0e0 25%, #f0f0f0 50%, #e0e0e0 75%);
                                    background-size: 200px 100%;
                                    border-radius: 4px;
                                    animation: shimmer 1.2s infinite linear;
                                    }
                                `}
                            </style>
                            <table
                                style={{
                                    width: "100%",
                                    borderCollapse: "separate",
                                    borderSpacing: "0 10px",
                                }}
                            >
                                <thead>
                                    <tr
                                        style={{
                                            background:
                                                "linear-gradient(180deg, rgba(24, 119, 242, 0.11) -1.89%, rgba(24, 119, 242, 0.00) 60.38%)",
                                            borderBottom: "5px solid #1877F2",
                                        }}
                                    >
                                        <th
                                            style={{
                                                padding: "10px",
                                                textAlign: "left",
                                                fontWeight: "bold",
                                                fontSize: "16px",
                                                color: "#000",
                                                cursor: "pointer",
                                            }}
                                            onClick={() => handleSort("forecaster")}
                                        >
                                            Forecaster {sortOrder.forecaster === "asc" ? "↑" : "↓"}
                                        </th>
                                        <th
                                            style={{
                                                padding: "10px",
                                                textAlign: "center",
                                                fontWeight: "bold",
                                                fontSize: "16px",
                                                color: "#000",
                                                cursor: "pointer",
                                            }}
                                            onClick={() => handleSort("target")}
                                        >
                                            Target {sortOrder.target === "asc" ? "↑" : "↓"}
                                        </th>
                                        <th
                                            style={{
                                                padding: "10px",
                                                textAlign: "center",
                                                fontWeight: "bold",
                                                fontSize: "16px",
                                                color: "#000",
                                                cursor: "pointer",
                                            }}
                                            onClick={() => handleSort("accuracy")}
                                        >
                                            Past Accuracy {sortOrder.accuracy === "asc" ? "↑" : "↓"}
                                        </th>
                                        <th
                                            style={{
                                                padding: "10px",
                                                textAlign: "center",
                                                fontWeight: "bold",
                                                fontSize: "16px",
                                                color: "#000",
                                                cursor: "pointer",
                                            }}
                                            onClick={() => handleSort("percent")}
                                        >
                                            % Target Achieved {sortOrder.percent === "asc" ? "↑" : "↓"}
                                        </th>
                                        <th
                                            style={{
                                                padding: "10px",
                                                textAlign: "center",
                                                fontWeight: "bold",
                                                fontSize: "16px",
                                                color: "#000",
                                                cursor: "pointer",
                                            }}
                                            onClick={() => handleSort("targetDate")}
                                        >
                                            Forecast For {sortOrder.targetDate === "asc" ? "↑" : "↓"}
                                        </th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {loading || (loading && isEligible === undefined) ? (
                                        <SkeletonLoader />
                                    ) : !userData || !isEligible ? (
                                        <tr>
                                            <td colSpan={6}>
                                                <div
                                                    style={{
                                                        position: "relative",
                                                        border: "1px solid #B6B6B8",
                                                        margin: "3% 0% 2% 0%",
                                                        padding: "2%",
                                                        borderRadius: "8px",
                                                        textAlign: "center",
                                                        height: "30vh",
                                                        overflow: "hidden", // Ensures content stays within the div
                                                    }}
                                                >
                                                    {/* Blurred background image */}
                                                    <div
                                                        style={{
                                                            backgroundImage: `url(${window.constants.asset_path}/images/default-recommed.png)`,
                                                            backgroundSize: "cover",
                                                            backgroundPosition: "center center",
                                                            filter: "blur(5px)",
                                                            position: "absolute",
                                                            top: 0,
                                                            left: 0,
                                                            width: "100%",
                                                            height: "100%",
                                                            zIndex: 0,
                                                        }}
                                                    ></div>

                                                    {/* Overlay content without blur */}
                                                    <div
                                                        style={{
                                                            position: "relative",
                                                            zIndex: 1,
                                                            display: "flex",
                                                            flexDirection: "column",
                                                            justifyContent: "center",
                                                            alignItems: "center",
                                                            height: "100%",
                                                        }}
                                                    >
                                                        <style>{leftRightMotion}</style>
                                                        <div
                                                            style={{
                                                                position: "relative",
                                                                width: "64px",
                                                                height: "64px",
                                                            }}
                                                        >
                                                            {/* Lens image with left-right motion animation */}

                                                            {!isEligible || !userData ? (
                                                                <img
                                                                    src={
                                                                        window.constants.asset_path + "/images/lock.svg"
                                                                    }
                                                                    alt="lock"
                                                                    style={{
                                                                        width: "45px",
                                                                        height: "45px",
                                                                        cursor: "pointer",
                                                                    }}
                                                                    onClick={(e) => {
                                                                        e.preventDefault(); // Prevent navigation

                                                                        const originalUrl = `${process.env.REACT_APP_HOME_URL}crypto-predictions/best-predictions`; // Use backticks for template literals
                                                                        sessionStorage.setItem(
                                                                            "originalUrl",
                                                                            originalUrl
                                                                        ); // Save the original URL to sessionStorage

                                                                        handleLoginClick(); // Trigger the login click handler
                                                                    }}
                                                                />
                                                            ) : (
                                                                <img
                                                                    src={
                                                                        window.constants.asset_path + "/images/lens.png"
                                                                    }
                                                                    alt="Searching Lens"
                                                                    style={{
                                                                        width: "64px",
                                                                        height: "64px",
                                                                        position: "absolute",
                                                                        animation: `leftRightMotion 1.5s infinite ease-in-out`,
                                                                    }}
                                                                />
                                                            )}
                                                        </div>
                                                        <p
                                                            style={{
                                                                fontFamily: "Satoshi,sans-serif",
                                                                marginTop: "10px",
                                                                fontSize: "18px",
                                                                color: "black",
                                                            }}
                                                        >
                                                            <b>
                                                                {!userData
                                                                    ? LOGIN_MESSAGE()
                                                                    : !isEligible && BEST_PREDICTION_MESSAGE()}
                                                            </b>
                                                        </p>
                                                    </div>
                                                </div>
                                            </td>
                                        </tr>
                                    ) : sortedData.length == 0 ? (
                                        <tr>
                                            <td
                                                colSpan="5"
                                                style={{
                                                    textAlign: "center",
                                                    padding: "20px",
                                                    fontSize: "16px",
                                                    fontWeight: "bold",
                                                    border: "2px solid #1877F2",
                                                    borderRadius: "10px",
                                                    background: "#f8f9fa",
                                                    color: "#1877F2",
                                                }}
                                            >
                                                No Predictions Available
                                            </td>
                                        </tr>
                                    ) : (
                                        sortedData.map((data, index) => (
                                            <tr
                                                key={index}
                                                ref={index === sortedData.length - 1 ? lastRowRef : null}
                                                style={{
                                                    background: "#fff",
                                                    borderRadius: "10px",
                                                    boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
                                                    marginBottom: "10px",
                                                    border: "2px solid #1877F2",
                                                }}
                                            >
                                                <td
                                                    style={{
                                                        border: "1px solid #1877F2",
                                                        borderTopLeftRadius: "20px",
                                                        borderBottomLeftRadius: "20px",
                                                        borderRight: "none",
                                                        padding: "10px",
                                                    }}
                                                >
                                                    <div
                                                        style={{
                                                            padding: "10px",
                                                            fontWeight: "bold",
                                                            fontSize: "16px",
                                                            color: "#000",
                                                            background:
                                                                "linear-gradient(91deg, #9AFFF9 18.86%, #FFF06D 100.02%)",
                                                            borderRadius: "10px",
                                                            textAlign: "left",
                                                            minWidth: "220px",
                                                            display: "flex",
                                                            justifyContent: "space-between",
                                                        }}
                                                    >
                                                        <div style={{display: "flex", alignItems: "center"}}>
                                                            {" "}
                                                            <img
                                                                src={
                                                                    data.photo &&
                                                                    data.photo !==
                                                                        "https://crowdwisdom.live/wp-content/plugins/forcaster-accuracy-plugin/images/"
                                                                        ? data.photo
                                                                        : window.constants.asset_path +
                                                                          "/images/avtar.jpeg"
                                                                }
                                                                alt="Forecaster"
                                                                style={{
                                                                    width: "30px",
                                                                    height: "30px",
                                                                    borderRadius: "50%",
                                                                    marginRight: "5px",
                                                                }} // Adjust size and shape as needed
                                                            />
                                                            {data.forecaster_name}
                                                        </div>
                                                        <div
                                                            style={{display: "flex", alignItems: "center", gap: "8px"}}
                                                        >
                                                            <img
                                                                src={`https://s2.coinmarketcap.com/static/img/coins/64x64/${data.cmc_id}.png`}
                                                                alt={data.slug}
                                                                style={{width: "24px", height: "24px"}}
                                                            />
                                                            <div>{data.slug}</div>
                                                        </div>
                                                    </div>
                                                </td>
                                                <td
                                                    style={{
                                                        padding: "10px",
                                                        textAlign: "center",
                                                        fontWeight: "500",
                                                        fontSize: "14px",
                                                        color: "#000",
                                                        border: "1px solid #1877F2",
                                                        borderLeft: "none",
                                                        borderRight: "none",
                                                        padding: "10px",
                                                    }}
                                                >
                                                    {data.forecast_price}
                                                </td>
                                                <td
                                                    style={{
                                                        padding: "10px",
                                                        textAlign: "center",
                                                        fontWeight: "500",
                                                        fontSize: "14px",
                                                        color: "#000",
                                                        border: "1px solid #1877F2",
                                                        borderLeft: "none",
                                                        borderRight: "none",
                                                        padding: "10px",
                                                    }}
                                                >
                                                    {data.accuracy}
                                                </td>
                                                <td
                                                    style={{
                                                        padding: "10px",
                                                        textAlign: "center",
                                                        fontWeight: "500",
                                                        fontSize: "14px",
                                                        color: "#000",
                                                        border: "1px solid #1877F2",
                                                        borderLeft: "none",
                                                        borderRight: "none",
                                                        padding: "10px",
                                                    }}
                                                >
                                                    {data.target_percent}
                                                </td>
                                                <td
                                                    style={{
                                                        padding: "10px",
                                                        textAlign: "center",
                                                        fontWeight: "500",
                                                        fontSize: "14px",
                                                        color: "#000",
                                                        border: "1px solid #1877F2",
                                                        borderLeft: "none",
                                                        borderTopRightRadius: "20px",
                                                        borderBottomRightRadius: "20px",
                                                        padding: "10px",
                                                    }}
                                                >
                                                    {data.target_date}
                                                </td>
                                            </tr>
                                        ))
                                    )}
                                </tbody>
                            </table>
                            {loadingMore && (
                                <div className="d-flex justify-content-center my-5">
                                    <CircularProgress />
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            ) : (
                <>
                    <div style={{padding: "10px", paddingTop: "200px"}}>
                        {/* Multi-Select Dropdowns */}
                        <div
                            style={{
                                display: "grid",
                                gridTemplateColumns: "1fr 1fr",
                                gap: "15px",
                                justifyContent: "center",
                            }}
                        >
                            {dropdowns.map((dropdown, index) => (
                                <div key={index} style={{width: dropdown.width, height: dropdown.height}}>
                                    <Select
                                        options={dropdown.options}
                                        isMulti
                                        placeholder={dropdown.label}
                                        value={dropdown.value} // The selected values
                                        onChange={(selectedOptions) => {
                                            dropdown.setValue(selectedOptions);
                                        }}
                                        closeMenuOnSelect={false} // Keep dropdown open
                                        hideSelectedOptions={false} // Keep selected options in the list
                                        styles={{
                                            dropdownIndicator: (base) => ({
                                                ...base,
                                                color: "black",
                                            }),
                                            indicatorSeparator: (base) => ({
                                                ...base,
                                                display: "none",
                                            }),
                                            control: (base) => ({
                                                ...base,
                                                background: "linear-gradient(91deg, #9AFFF9 18.86%, #FFF06D 100.02%)",
                                                border: "2px solid #79A7FF",
                                                borderRadius: "10px",
                                                padding: "2px",
                                                fontSize: "14px",
                                                fontWeight: "bold",
                                                color: "#000",
                                                cursor: "pointer",
                                            }),
                                            menu: (base) => ({
                                                ...base,
                                                background: "#fff",
                                                borderRadius: "10px",
                                                boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
                                                color: "#000",
                                            }),
                                            multiValue: (base) => ({
                                                ...base,
                                                display: "none", // Hide selected values inside the input field
                                            }),
                                            valueContainer: (base, state) => {
                                                const showLabel = !state.selectProps.inputValue; // Hide label while typing

                                                return {
                                                    ...base,
                                                    padding: "4px",
                                                    position: "relative",
                                                    ":before": showLabel
                                                        ? {
                                                              content: `"${dropdown.label}"`,
                                                              color: "#000",
                                                              fontWeight: "bold",
                                                              fontSize: "14px",
                                                              position: "absolute",
                                                              left: "10px",
                                                              top: "50%",
                                                              transform: "translateY(-50%)",
                                                          }
                                                        : {},
                                                };
                                            },
                                            placeholder: (base) => ({
                                                ...base,
                                                display: "none", // Hide default placeholder since we use :before
                                            }),
                                        }}
                                        components={{Option: CustomOption}}
                                    />
                                </div>
                            ))}
                        </div>

                        <div
                            style={{
                                position: "fixed",
                                top: 0,
                                left: 0, // aligns it to the right of the sidebar
                                width: "100%", // takes full width minus sidebar
                                backgroundColor: "#ffffff",
                                zIndex: 1000,
                                boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                                height: "100px",
                                display: "flex",
                                flexDirection: "column",
                            }}
                        >
                            <PromoBanner />
                            <TopNavigationMobile unreadAlerts={unreadAlerts} />
                        </div>

                        {/* Selected Filters */}
                        <div style={{display: "flex", flexWrap: "wrap", justifyContent: "center", marginTop: "15px"}}>
                            {dropdowns.map((dropdown, index) =>
                                dropdown.value.map((item) => (
                                    <div
                                        key={`${index}-${item.value}`}
                                        style={{
                                            display: "flex",
                                            alignItems: "center",
                                            backgroundColor: "#fff",
                                            color: "#000",
                                            borderRadius: "10px",
                                            padding: "5px 10px",
                                            margin: "5px",
                                            fontWeight: "bold",
                                            border: "1px solid #1877F2",
                                        }}
                                    >
                                        {(dropdown.label === "Crypto" || dropdown.label === "Influencer Name") &&
                                            item.image && (
                                                <img
                                                    src={
                                                        item.image?.trim()
                                                            ? item.image
                                                            : window.constants.asset_path + "/images/avtar.jpeg"
                                                    }
                                                    alt={item.label}
                                                    style={{
                                                        width: "30px",
                                                        height: "30px",
                                                        marginRight: "8px",
                                                        borderRadius: "50%",
                                                    }}
                                                />
                                            )}

                                        {item.label}
                                    </div>
                                ))
                            )}
                        </div>
                    </div>

                    {loading || (loading && isEligible === undefined) ? (
                        <SkeletonLoaderMobileList />
                    ) : !userData || !isEligible ? (
                        <div
                            style={{
                                position: "relative",
                                border: "1px solid #B6B6B8",
                                margin: "3% 0% 2% 0%",
                                padding: "2%",
                                borderRadius: "8px",
                                textAlign: "center",
                                height: "30vh",
                                overflow: "hidden", // Ensures content stays within the div
                            }}
                        >
                            {/* Blurred background image */}
                            <div
                                style={{
                                    backgroundImage: `url(${window.constants.asset_path}/images/default-recommed.png)`,
                                    backgroundSize: "cover",
                                    backgroundPosition: "center center",
                                    filter: "blur(5px)",
                                    position: "absolute",
                                    top: 0,
                                    left: 0,
                                    width: "100%",
                                    height: "100%",
                                    zIndex: 0,
                                }}
                            ></div>

                            {/* Overlay content without blur */}
                            <div
                                style={{
                                    position: "relative",
                                    zIndex: 1,
                                    display: "flex",
                                    flexDirection: "column",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    height: "100%",
                                }}
                            >
                                <style>{leftRightMotion}</style>
                                <div
                                    style={{
                                        position: "relative",
                                        width: "64px",
                                        height: "64px",
                                    }}
                                >
                                    {/* Lens image with left-right motion animation */}

                                    {!isEligible || !userData ? (
                                        <img
                                            src={window.constants.asset_path + "/images/lock.svg"}
                                            alt="lock"
                                            style={{
                                                width: "45px",
                                                height: "45px",
                                                cursor: "pointer",
                                            }}
                                            onClick={(e) => {
                                                e.preventDefault(); // Prevent navigation

                                                const originalUrl = `${process.env.REACT_APP_HOME_URL}crypto-predictions/best-predictions`; // Use backticks for template literals
                                                sessionStorage.setItem("originalUrl", originalUrl); // Save the original URL to sessionStorage

                                                handleLoginClick(); // Trigger the login click handler
                                            }}
                                        />
                                    ) : (
                                        <img
                                            src={window.constants.asset_path + "/images/lens.png"}
                                            alt="Searching Lens"
                                            style={{
                                                width: "64px",
                                                height: "64px",
                                                position: "absolute",
                                                animation: `leftRightMotion 1.5s infinite ease-in-out`,
                                            }}
                                        />
                                    )}
                                </div>
                                <p
                                    style={{
                                        fontFamily: "Satoshi,sans-serif",
                                        marginTop: "10px",
                                        fontSize: "18px",
                                        color: "black",
                                    }}
                                >
                                    <b>{!userData ? LOGIN_MESSAGE() : !isEligible && BEST_PREDICTION_MESSAGE()}</b>
                                </p>
                            </div>
                        </div>
                    ) : sortedData.length === 0 ? (
                        <div
                            style={{
                                border: "1px solid #1877F2",
                                margin: "0px 2%",
                                textAlign: "center",
                                color: "#1877F2",
                                fontSize: "18px",
                                backgroundColor: "white",
                                padding: "2%",
                                borderRadius: "8px",
                                marginBottom: "50%",
                            }}
                        >
                            No Predictions available
                        </div>
                    ) : (
                        <div style={{padding: "10px", marginBottom: "60px"}}>
                            {sortedData.map((data, index) => (
                                <MobileForecastCard
                                    key={index}
                                    data={data}
                                    ref={index === sortedData.length - 1 ? lastRowRef : null}
                                />
                            ))}
                        </div>
                    )}
                    {loadingMore && (
                        <div className="d-flex justify-content-center my-5">
                            <CircularProgress />
                        </div>
                    )}
                </>
            )}

            {mediaQueryVar === false && (
                <div
                    style={{
                        position: "fixed",
                        bottom: "0",
                        backgroundColor: "white",
                        width: "105%",
                        zIndex: "100",
                        marginBottom: "0px",
                        marginLeft: "-25px",
                    }}
                >
                    <BottomNavigation showLabels>
                        <BottomNavigationAction
                            label="Top Portfolios"
                            onClick={() => navigate("/portfolio-gallery")}
                            icon={
                                <img
                                    src={
                                        loc === "/portfolio-gallery"
                                            ? "/images/dashboardS.svg"
                                            : "/images/dashboardU.svg"
                                    }
                                    width={"20px"}
                                    height={"20px"}
                                />
                            }
                        />
                        <BottomNavigationAction
                            label="Crypto Screener"
                            onClick={() => navigate("/crypto-screener")}
                            icon={
                                <img
                                    src={
                                        loc === "/crypto-screener" ? "/images/portfolioS.svg" : "/images/portfolioU.svg"
                                    }
                                    width={"20px"}
                                    height={"20px"}
                                />
                            }
                        />
                        <BottomNavigationAction
                            label="Indices"
                            onClick={() => {
                                navigate("/indices");
                            }}
                            icon={
                                <img
                                    src={"/images/dollarU.svg"}
                                    width={24}
                                    height={24}
                                    alt="Icon"
                                    style={{marginBottom: "-3px"}}
                                />
                            }
                        />
                    </BottomNavigation>
                </div>
            )}
            {isLoginModalOpen && (
                <LoginPopUp
                    isLoginModalOpen={isLoginModalOpen}
                    setLoginModalOpen={setLoginModalOpen} // Pass the state setter down
                    onClose={handleModalClose}
                />
            )}
            {goToSubscribeAlertOpen && (
                <GoToSubscribeAlert onClose={setGoToSubscribeAlertOpen} text={subscriptionText} />
            )}
            <GoogleLoginHandler redirectUrl={location.pathname} />
            <Modal
                style={{
                    overlay: {
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        backgroundColor: "rgba(0, 0, 0, 0.5)",
                        zIndex: 1000,
                        marginLeft: mediaQueryVar === true ? "20%" : "",
                    },
                    content: {
                        align: "center",
                        width: "80%",
                        marginBottom: "20%",
                        height: "auto",
                        borderRadius: "8px",
                        position: "center",
                    },
                }}
                isOpen={modalIsOpen}
                onRequestClose={closeModal}
                contentLabel="Accuracy Details"
            >
                <img
                    className="frameIcon"
                    alt=""
                    onClick={closeModal}
                    src="/images/frame17.svg"
                    style={{
                        background: "#F3F3F3",
                        width: "25px",
                        height: "25px",
                        marginTop: "1.5%",
                        marginBottom: "1%",
                    }}
                />
                <h4>Past Accuracy</h4>
                {modalData ? (
                    <table className="modal-table">
                        <thead>
                            <tr>
                                <th>Published On</th>
                                <th>Forecast Date</th>
                                <th style={{textAlign: "center"}}>Forecast Price</th>
                                <th style={{textAlign: "center"}}>Accuracy</th>
                            </tr>
                        </thead>
                        <tbody>
                            {modalData.map((detail, index) => (
                                <tr key={index}>
                                    <td>{detail.publish_date}</td>
                                    <td>{detail.target_date} 11:59 PM</td>
                                    <td style={{textAlign: "center"}}>{detail.forecast_price}</td>
                                    <td style={{textAlign: "center"}}>{detail.accuracy}%</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                ) : (
                    <p>No data available</p>
                )}
            </Modal>
        </div>
    );
};

export default TopPredictionsPage;
